/**
 * The neutral full-screen "still deciding" screen.
 *
 * Shown by `useBootGate` while the session is being restored, and by
 * `RequireOrderSettled` while it decides whether the member is locked to a
 * payment page. The copy is deliberately IDENTICAL in both places: on a hard
 * reload the boot gate has already painted this exact markup, so a guard that
 * holds afterwards simply leaves it on screen. No swap, no flicker, no jump —
 * the user just sees one continuous splash until the first real screen is
 * final.
 *
 * Do NOT reword this per caller. A different string here would turn a seamless
 * hold into a visible text swap, which is the flash this component exists to
 * remove.
 *
 * Distinct from `StorefrontFallback` in App.tsx, which is the lazy-chunk
 * fallback for the public storefront and carries the storefront's own palette.
 */
export function BootSplash() {
  return (
    <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">
      Restoring session…
    </div>
  );
}
